module.exports = "https://r.nearpod.com/assets/media/image/checked-icon-591570a4aaacaee0a9f0bab4b0f311ba.svg";